<template>
  <div class="flex flex-col justify-center mr-2">
    <label :for="id + '_button'" class="toggle__label" :class="!checked ? activeClass : '', defaultClass">{{ labelFrom }}</label>
    <label :for="id + '_button'" :class="{'active': checked}" class="toggle__button flex items-center justify-center my-2">
      <input type="checkbox" :disabled="disabled" :id="id + '_button'"  :checked="checked" @input="(event) => $emit('update:checked', event.target.checked)">
      <span class="toggle__switch"></span>
    </label>
    <label :for="id + '_button'" class="toggle__label" :class="checked ? activeClass : '', defaultClass">{{ labelTo }}</label>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    labelFrom: {
      type: String,
      default: 'From'
    },
    labelTo: {
      type: String,
      default: 'To'
    },
    id: {
      type: String,
      default: 'primary'
    },
    checked: {
      type: Boolean
    },
    defaultState: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeClass: 'text-primary-default scale-150',
      defaultClass: 'text-sm cursor-pointer block drop-shadow-sm transition-all ease-in-out duration-500 rounded-full bg-white flex items-center justify-center text-center p-2 w-5 h-5'
    }
  }
}
</script>

<style scoped>
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display:inline-block;
  height:40px;
  border-radius:6px;
  width:12px;
  background: var(--color-neutral-lighter);
  box-shadow: inset 0 0 1px var(--color-neutral-light);
  position:relative;

  transition: all .25s;
}

.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  left: -4px;
  top: 0;
  transform: translateX(0);
  transition: all .25s cubic-bezier(.5, -.6, .5, 1.6);
}

.toggle__button .toggle__switch::after {
  background: var(--color-primary);
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #4D4D4D;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.1);
  opacity:0;
}

.active .toggle__switch {
  /*
  background: #adedcb;
  box-shadow: inset 0 0 1px #adedcb;
  */
}

.active .toggle__switch::after,
.active .toggle__switch::before{
  transform:translateY(40px - 18px);
}

.active .toggle__switch::after {
  top: 20px;
  /*
  background: #53B883;
  box-shadow: 0 0 1px #53B883;
  */

}
</style>